export default {
  data: function () {
    var self = this;
    return {
      article: {},
      articleId: self.$route.params.articleId,
      formValidator: null
    };
  },
  methods: {
    loadData: function () {
      var self = this;
      self.$app.request.json('static/datasets/articles.json', function (data) {
        if (data) {
          self.$setState({
            article: data.find(function (a) {
              return a.id == self.$route.params.articleId;
            })
          });
        }
      });
    },
    // initializeFormValidator: function() {
    // 	var self = this;
    // 	self.formValidator = jQuery('form[name=review]').validate({
    // 		ignore: [],
    // 		rules: {
    // 			name: {
    // 				required: true
    // 			},
    // 			email: {
    // 				required: true,
    // 				email: true
    // 			},
    // 			comment: {
    // 				required: true
    // 			}
    // 		},
    // 		messages: {
    // 			name: {
    // 				required: 'Please enter name.'
    // 			},
    // 			email: {
    // 				required: 'Please enter email address.',
    // 				email: 'Please enter a valid email address.'
    // 			},
    // 			comment: {
    // 				required: 'Please enter comment.'
    // 			}
    // 		},
    // 		submitHandler: function(form) {
    // 			self.submitForm(form);
    // 		}
    // 	});
    // },
    submitForm: function (form) {
      var self = this;
      app.toast.show({
        text: 'Thank you for the comment.',
        position: 'bottom',
        cssClass: 'toast-round bg-color-green'
      });
      document.querySelector('form[name=review]').reset();
      app.popup.close('.popup-review', false);
    }
  },
  on: {
    pageInit: function () {
      var self = this; // self.initializeFormValidator();

      self.loadData();
    }
  },
  id: '85b82e2378',

  render() {
    return function (ctx_1, data_1, root) {
      function isArray(arr) {
        return Array.isArray(arr);
      }

      function isFunction(func) {
        return typeof func === 'function';
      }

      function c(val, ctx) {
        if (typeof val !== "undefined" && val !== null) {
          if (isFunction(val)) {
            return val.call(ctx);
          } else return val;
        } else return "";
      }

      root = root || ctx_1 || {};
      var r = '';
      r += '\n	<div class="page">\n		<div class="navbar">\n      <div class="navbar-bg"></div>\n			<div class="navbar-inner sliding">\n				<div class="left">\n					<a href="#" class="link back">\n						<i class="icon icon-back"></i>\n						<span class="ios-only" data-i18n="back">Back</span>\n					</a>\n				</div>\n				<div class="title">';
      r += c(ctx_1.article.title, ctx_1);
      r += '</div>\n				<!-- <div class="subnavbar ios-only">\n					<div class="subnavbar-inner">\n						<div class="title" data-i18n="articles-single">';
      r += c(ctx_1.article.title, ctx_1);
      r += '</div>\n					</div>\n				</div> -->\n			</div>\n		</div>\n\n		<div class="page-content hide-navbar-on-scroll">\n\n			<div class="article-header" style="background-image: url(';
      r += c(ctx_1.article.image, ctx_1);
      r += ');">\n				<div class="article-title">';
      r += c(ctx_1.article.title, ctx_1);
      r += '</div>\n				<div class="article-categories">\n          <div class="badge color-yellow text-color-black" style=\'padding: 0 .8em 0.2em .8em\'>';
      r += c(ctx_1.article.topic, ctx_1);
      r += '</div>\n				</div>\n			</div>\n\n			<div class="article-content">\n				<p class="dropcap">Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur.</p>\n				<img class="img-responsive img-center" src="https://source.unsplash.com/twukN12EN7c" alt="" />\n				<p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga.</p>\n				<!-- <div class="embed">\n					<iframe class="embed-content" src="https://www.yo utube.com/embed/1ZYbU82GVz4"></iframe>\n				</div> -->\n				<p>Et harum quidem rerum facilis est et expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus. Temporibus autem quibusdam et aut officiis debitis aut rerum necessitatibus saepe eveniet ut et voluptates repudiandae sint et molestiae non recusandae.</p>\n			</div>\n\n			<!-- <div class="article-comments">\n				<div class="card no-margin">\n					<div class="card-header">Comments</div>\n					<div class="card-content card-content-padding">\n						<div class="list media-list no-hairlines no-hairlines-between">\n							<ul>\n								<li>\n									<div class="item-content">\n										<div class="item-media">\n											<img class="img-circle" src="https://randomuser.me/api/portraits/women/79.jpg" width="48" alt="" />\n										</div>\n										<div class="item-inner">\n											<div class="item-title-row">\n												<div class="item-title">Line Rolland</div>\n											</div>\n											<div class="item-subtitle">Excepteur sint occaecat cupidatat non proident.</div>\n											<div class="item-text">7 days ago</div>\n										</div>\n									</div>\n								</li>\n								<li>\n									<div class="item-content">\n										<div class="item-media">\n											<img class="img-circle" src="https://randomuser.me/api/portraits/women/17.jpg" width="48" alt="" />\n										</div>\n										<div class="item-inner">\n											<div class="item-title-row">\n												<div class="item-title">Lilja Peltola</div>\n											</div>\n											<div class="item-subtitle">Cillum dolore eu fugiat nulla pariatur.</div>\n											<div class="item-text">2 months ago</div>\n										</div>\n									</div>\n								</li>\n								<li>\n									<div class="item-content">\n										<div class="item-media">\n											<img class="img-circle" src="https://randomuser.me/api/portraits/women/44.jpg" width="48" alt="" />\n										</div>\n										<div class="item-inner">\n											<div class="item-title-row">\n												<div class="item-title">Jane Zhu</div>\n											</div>\n											<div class="item-subtitle">Sunt in culpa qui officia deserunt mollit anim id est laborum.</div>\n											<div class="item-text">1 year ago</div>\n										</div>\n									</div>\n								</li>\n							</ul>\n						</div>\n					</div>\n					<div class="card-footer justify-content-center">\n						<a href="#" class="link popup-open" data-popup=".popup-review">Write a Comment</a>\n					</div>\n				</div>\n			</div> -->\n\n		</div>\n\n		<!-- <div class="fab fab-right-bottom color-yellow">\n			<a href="#">\n				<i class="icon material-icons color-black">add</i>\n				<i class="icon material-icons color-black">close</i>\n			</a>\n			<div class="fab-buttons fab-buttons-top">\n				<a href="#" class="fab-label-button bg-color-green">\n					<i class="icon material-icons">share</i>\n					<span class="fab-label">Share</span>\n				</a>\n				<a href="#" class="fab-label-button bg-color-blue">\n					<i class="icon material-icons">mode_comment</i>\n					<span class="fab-label">Comment</span>\n				</a>\n				<a href="#" class="fab-label-button bg-color-pink">\n					<i class="icon material-icons">favorite</i>\n					<span class="fab-label">Like</span>\n				</a>\n			</div>\n		</div> -->\n\n		<div class="popup popup-tablet-fullscreen popup-review">\n			<div class="view">\n				<div class="page">\n\n					<div class="navbar">\n						<div class="navbar-inner">\n							<div class="left ios-only">\n								<a href="#" class="link popup-close" data-popup=".popup-review">\n									<span data-i18n="cancel">Cancel</span>\n								</a>\n							</div>\n							<div class="title">Write a Comment</div>\n							<div class="right ios-only">\n								<button type="submit" class="button link" form="review" data-i18n="submit">Submit</button>\n							</div>\n							<div class="right md-only">\n								<a href="#" class="link icon-only popup-close" data-popup=".popup-review">\n									<i class="icon material-icons">close</i>\n								</a>\n							</div>\n						</div>\n					</div>\n\n					<div class="page-content">\n\n						<form id="review" name="review" action="#" method="POST" enctype="multipart/form-data">\n							<div class="list no-hairlines no-hairlines-between">\n								<ul>\n									<li>\n										<div class="item-content item-input item-input-with-info">\n											<div class="item-media">\n												<i class="icon f7-icons ios-only">person</i>\n												<i class="icon material-icons md-only">person</i>\n											</div>\n											<div class="item-inner">\n												<div class="item-title item-floating-label">Name</div>\n												<div class="item-input-wrap">\n													<input type="text" name="name" required />\n													<div class="item-input-info input-error-message"></div>\n												</div>\n											</div>\n										</div>\n									</li>\n									<li>\n										<div class="item-content item-input item-input-with-info">\n											<div class="item-media">\n												<i class="icon f7-icons ios-only">email</i>\n												<i class="icon material-icons md-only">email</i>\n											</div>\n											<div class="item-inner">\n												<div class="item-title item-floating-label">Email</div>\n												<div class="item-input-wrap">\n													<input type="email" name="email" required />\n													<div class="item-input-info input-error-message"></div>\n												</div>\n											</div>\n										</div>\n									</li>\n									<li>\n										<div class="item-content item-input item-input-with-info">\n											<div class="item-media">\n												<i class="icon f7-icons ios-only">message</i>\n												<i class="icon material-icons md-only">message</i>\n											</div>\n											<div class="item-inner">\n												<div class="item-title item-floating-label">Comment</div>\n												<div class="item-input-wrap">\n													<textarea name="comment" class="resizable" required></textarea>\n													<div class="item-input-info input-error-message"></div>\n												</div>\n											</div>\n										</div>\n									</li>\n								</ul>\n							</div>\n							<div class="block md-only">\n								<button type="submit" class="button button-big button-fill" data-i18n="submit">Submit</button>\n							</div>\n						</form>\n\n					</div>\n\n				</div>\n			</div>\n		</div>\n\n	</div>\n';
      return r;
    }(this);
  },

  style: `
[data-f7-85b82e2378] .article-header {
		align-items: flex-start;
		background-color: #292929;
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
		box-sizing: border-box;
		color: #FFFFFF;
		display: flex;
		flex-direction: column;
		height: 45vh;
		justify-content: flex-end;
		padding: 16px;
	}

[data-f7-85b82e2378] .article-header .article-title {
		font-size: 1.6em;
    text-shadow: 1px 1px 10px #000000;
	}

[data-f7-85b82e2378] .article-header .article-categories .badge {
		font-size: 14px;
		margin-top: 8px;
		margin-right: 4px;
	}

[data-f7-85b82e2378] .article-content {
		box-sizing: border-box;
		padding: 16px;
	}

[data-f7-85b82e2378] .article-comments {
		box-sizing: border-box;
		padding: 0 16px 32px 16px;
	}

[data-f7-85b82e2378] .article-comments .list .item-title {
		font-size: 14px;
	}

[data-f7-85b82e2378] .article-comments .list .item-subtitle {
		font-size: 13px;
	}

[data-f7-85b82e2378] .article-comments .list .item-text {
		font-size: 12px;
	}
`,
  styleScoped: true
};